import * as Yup from "yup";
import { TFunction } from "i18next";

type Translator = (key: string, vars?: Record<string, any>) => string;

export default function savePlantSchema(t: TFunction | Translator) {
  return Yup.object().shape({
    name: Yup.string()
      .required(
        t("Plant.validations.required", {
          value: t("Plant.name"),
        })
      )
      .min(3)
      .max(255),
    location: Yup.string()
      .required(
        t("Plant.validations.required", {
          value: t("Plant.location"),
        })
      )
      .min(3)
      .max(255),
    admin_fee: Yup.number()
      .required(
        t("Plant.validations.required", {
          value: t("Plant.admin_fee"),
        })
      )
      .min(
        0,
        t("Plant.validations.decimalNum", {
          value: t("Plant.admin_fee"),
        })
      ),
    external_id: Yup.string()
      .matches(
        /^\d*$/,
        t("Plant.validations.onlyDigits", {
          value: t("Plant.external_id"),
        })
      )
      .test(
        "min-length-when-provided",
        t("Plant.validations.min", {
          value: t("Plant.external_id"),
          min: 8,
        }),
        function (value) {
          if (!value || value.length === 0) return true; // Allow empty since not required
          return value.length >= 8;
        }
      ),
    roleGroup: Yup.string().required(
      t("Plant.validations.required", {
        value: t("Plant.roleGroup"),
      })
    ),
    state: Yup.string().required(
      t("Plant.validations.required", {
        value: t("Plant.state"),
      })
    ),
    engagementStatus: Yup.string().required(
      t("Plant.validations.required", {
        value: t("Plant.engagementStatus"),
      })
    ),
    engagementStartDate: Yup.date().required(
      t("Plant.validations.required", {
        value: t("Plant.engagementStartDate"),
      })
    ),
  });
}
